export default __webpack_public_path__ + "static/media/wine_bar4.80ee5d9c.jpg";